import { Box, Image, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";

export const HeaderLogo = () => {
  const i18n = useI18n();

  return (
    <Stack direction="row" alignItems="center">
      <Image
        asset={{
          setName: "images-brand",
          assetName: "BookingComLogoDarkBackgroundsMono",
        }}
        alt="Booking.com Logo"
        height={6}
      />
      <Box backgroundColor="neutral_alt" mixin={{ padding: 0, width: 0.25, height: 4 }} />
      <Text variant="emphasized_1">{i18n.trans(t("flights_airline_portal_header_bar_name"))}</Text>
    </Stack>
  );
};
